import { render, staticRenderFns } from "./channelManagerModal.vue?vue&type=template&id=edc4ff74&scoped=true&"
import script from "./channelManagerModal.vue?vue&type=script&lang=js&"
export * from "./channelManagerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc4ff74",
  null
  
)

export default component.exports